module.exports = __webpack_public_path__ + "media/images/fleche bas-170d420f71f1560b155268296e5dc285.svg";